import React, { useMemo } from "react";

import clsx from "clsx";
import { useNavigate } from "react-router";

import RouteDrawer, { RouteDrawerProps } from "components/RouteDrawer";
import makeStyles from "hooks/makeStyles";

import CompanyInfoModal from "./CompanyInfoModal";

const useStyles = makeStyles(theme => ({
	root: {},
	paper: {
		borderRadius: `${theme.spacing(2)}px ${theme.spacing(2)}px 0 0`,
		backgroundColor: "rgba(33,33,33,0.7)",
		WebkitBackdropFilter: "blur(5px)",
		backdropFilter: "blur(5px)",
		color: "#fff",
		padding: theme.spacing(2),
		display: "flex",
		height: "45vh",
		overflow: "hidden",
		[theme.breakpoints.up(480)]: {
			height: "100vh",
			borderRadius: "0",
			width: "80%",
			maxWidth: "442px",
			left: "auto",
			backgroundColor: theme.palette.background.paper,
			padding: 0,
			color: theme.palette.text.primary
		},
		[theme.breakpoints.up(769)]: {
			width: "50%"
		}
	},
	backdrop: {
		backgroundColor: "rgba(0,0,0,0.1)",
		[theme.breakpoints.up(480)]: {
			backgroundColor: "transparent",
			WebkitBackdropFilter: "blur(1.8px)",
			backdropFilter: "blur(1.8px)"
		}
	}
}));

type Props = Omit<RouteDrawerProps, "swipeable" | "matchRoute">;

const CompanyInfoDrawer = ({ className, ...otherProps }: Props) => {
	const navigate = useNavigate();
	const classes = useStyles();

	const close = useMemo(
		() => () => {
			navigate(-1);
		},
		[navigate]
	);

	const props: RouteDrawerProps = useMemo(
		() =>
			Object.assign(
				{
					className: clsx(classes.root, className),
					classes: { paper: classes.paper },
					BackdropProps: {
						className: classes.backdrop
					},
					anchor: "bottom",
					disableSwipeToOpen: true,
					swipeable: false,
					matchRoute: ({ location: { hash } }) => hash.startsWith("#info"),
					onClose: close,
					onOpen: () => {}
				},
				otherProps
			),
		[className, classes.backdrop, classes.paper, classes.root, close, otherProps]
	);

	return (
		<RouteDrawer {...props}>
			<CompanyInfoModal onClose={close} />
		</RouteDrawer>
	);
};

export default CompanyInfoDrawer;
